import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Dịch vụ</h3>
          <ul>
            <li><Link to="/pricing">Gói dịch vụ</Link></li>
            <li><Link to="/overview">Tổng quan</Link></li>
            <li><Link to="/browse">Tìm kiếm</Link></li>
            <li><Link to="/accessibility">Khả năng tiếp cận <span className="beta-tag">BETA</span></Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Trị liệu</h3>
          <ul>
            <li><Link to="/brainstorming">Trị liệu cá nhân</Link></li>
            <li><Link to="/ideation">Trị liệu nhóm</Link></li>
            <li><Link to="/wireframing">Trị liệu gia đình</Link></li>
            <li><Link to="/research">Nghiên cứu</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Tài nguyên</h3>
          <ul>
            <li><Link to="/help">Trung tâm trợ giúp</Link></li>
            <li><Link to="/blog">Blog sức khỏe</Link></li>
            <li><Link to="/tutorials">Hướng dẫn tự chăm sóc</Link></li>
            <li><Link to="/faqs">Câu hỏi thường gặp</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Hỗ trợ</h3>
          <ul>
            <li><Link to="/contact">Liên hệ chúng tôi</Link></li>
            <li><Link to="/developers">Đối tác</Link></li>
            <li><Link to="/documentation">Tài liệu</Link></li>
            <li><Link to="/integrations">Tích hợp</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Công ty</h3>
          <ul>
            <li><Link to="/about">Giới thiệu</Link></li>
            <li><Link to="/press">Báo chí</Link></li>
            <li><Link to="/events">Sự kiện</Link></li>
            <li><Link to="/request-demo">Đặt lịch tư vấn →</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <span>© 2024 Learning to Mend. Tất cả quyền được bảo lưu.</span>
        </div>
        <div className="footer-bottom-right">
          <Link to="/terms">Điều khoản</Link>
          <Link to="/privacy">Quyền riêng tư</Link>
          <Link to="/contact">Liên hệ</Link>
          <div className="language-selector">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z" fill="currentColor"/>
              <path d="M8 2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" fill="currentColor"/>
            </svg>
            <span>EN</span>
          </div>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z" fill="currentColor"/>
          </svg>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
